import React from "react";
import { howItWorks, whyChooseUs, specialOffer, chefInfo } from "../mock";
import { Sparkles, ArrowRight } from "lucide-react";

function StepCard({ step }) {
  return (
    <div className="bg-white p-8 border border-neutral-200 service-card">
      <div className="font-display text-5xl text-neutral-300">{step.step}</div>
      <h4 className="font-display text-2xl mt-4 text-neutral-900">{step.title}</h4>
      <p className="mt-3 text-neutral-700 text-sm leading-relaxed">{step.text}</p>
    </div>
  );
}

function WhyItem({ item, index }) {
  return (
    <div className="bg-white p-6 border border-neutral-200 flex gap-5">
      <div className="w-10 h-10 rounded-full bg-neutral-900 text-[#fbf3e4] flex items-center justify-center flex-shrink-0 font-display">
        {String(index + 1).padStart(2, "0")}
      </div>
      <div>
        <h4 className="font-display text-lg text-neutral-900">{item.title}</h4>
        <p className="text-neutral-700 mt-1 text-sm leading-relaxed">{item.text}</p>
      </div>
    </div>
  );
}

export function HowItWorks() {
  return (
    <section id="how" className="bg-[#fbf3e4] py-24 lg:py-32 border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">HOW IT WORKS</p>
          <h3 className="font-display text-4xl md:text-6xl leading-[1] text-neutral-900">
            A simple four-step process
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.map((s) => (
            <StepCard key={s.id} step={s} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function WhyChooseUs() {
  return (
    <section id="why" className="bg-[#f3ead6] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">WHY CHOOSE US</p>
          <h3 className="font-display text-4xl md:text-6xl leading-[1] text-neutral-900">
            Four reasons clients keep coming back
          </h3>
          <p className="mt-6 text-neutral-700 text-lg leading-relaxed">
            A harmonious fusion of Turkish and international flavours, served with care and precision — from your first
            consultation to the last plate.
          </p>
        </div>
        <div className="space-y-5">
          {whyChooseUs.map((item, idx) => (
            <WhyItem key={item.id} item={item} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function SpecialOffer() {
  return (
    <section className="bg-neutral-950 text-[#fbf3e4] py-20">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 border border-neutral-700 px-4 py-2 mb-6">
          <Sparkles size={14} />
          <span className="text-xs tracking-[0.3em]">{specialOffer.title.toUpperCase()}</span>
        </div>
        <h3 className="font-display text-4xl md:text-6xl leading-[1]">{specialOffer.headline}</h3>
        <p className="mt-6 text-neutral-300 text-lg leading-relaxed max-w-2xl mx-auto">{specialOffer.text}</p>
        <a
          href="#contact"
          className="btn-primary mt-10 inline-flex items-center gap-2 bg-[#fbf3e4] text-neutral-900 px-7 py-3 text-sm font-medium tracking-wide hover:bg-white"
        >
          Claim Your Offer <ArrowRight size={16} />
        </a>
        <p className="text-xs text-neutral-500 mt-6 tracking-wider">
          {chefInfo.established} &middot; THE PRIVATE CHEF METE
        </p>
      </div>
    </section>
  );
}
